/**
 * Backend ConversationType values from /api/v1/Conversation/*.
 * Use these constants instead of hardcoded strings.
 */
export const CONVERSATION_TYPE = {
  DIRECT_CHAT: 'DirectChat',
  GROUP_CHAT: 'GroupChat',
  AI_CONVERSATION: 'AiConversation',
} as const;

export type ConversationType =
  (typeof CONVERSATION_TYPE)[keyof typeof CONVERSATION_TYPE];

/** Legacy / alternate AI conversation type strings seen in Agent APIs. */
export const AI_CONVERSATION_TYPES = [
  CONVERSATION_TYPE.AI_CONVERSATION,
  'AgentDirect',
  'WlbHelpAgent',
] as const;

/**
 * Rows per conversation-list request. Also the ceiling on any count derived
 * from a single list page, so badges know when their number is a floor.
 */
export const CONVERSATIONS_PAGE_SIZE = 20;

export type ParticipantSelectionMode = 'newConversation' | 'createGroup';

export const PARTICIPANT_SELECTION_MODE = {
  NEW_CONVERSATION: 'newConversation',
  CREATE_GROUP: 'createGroup',
} as const satisfies Record<string, ParticipantSelectionMode>;

export const isGroupConversationType = (type?: string | null): boolean => {
  if (!type) return false;
  if (type === CONVERSATION_TYPE.GROUP_CHAT) return true;
  return type.toLowerCase().includes('group');
};

export const isAiConversationType = (type?: string | null): boolean => {
  if (!type) return false;
  return (AI_CONVERSATION_TYPES as readonly string[]).includes(type);
};

export const isDirectConversationType = (type?: string | null): boolean => {
  if (!type) return true;
  return (
    type === CONVERSATION_TYPE.DIRECT_CHAT ||
    (!isGroupConversationType(type) && !isAiConversationType(type))
  );
};
